import {
  EstadoTransitoInventarioENUM,
  ROUTER_PATHS,
  formatDate,
  gridSize,
  gridSizeMdLg12,
  gridSizeMdLg4,
  texto,
  useUploadFile,
} from '@/shared';
import {
  LoaderComponent,
  SampleCheckbox,
  SingleTableBoxScene,
  TabTextLabel,
} from '@/shared/components/ui';
import {
  Grid,
  Paper,
} from '@mui/material';
import {
  AlertSeverityEnum,
  MaterialTransferido,
  EstadoSolicitudTransferencia,
  ISolicitudTrasladoForm,
} from '@/shared/interfaces';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useUiStore } from '@/store/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchCreateTransferenciaInventario, useFetchPutSolicitudTraslado, useFetchSolicitudTransferenciaInventarioById } from '@/shared/actions/erp';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SampleTablePagination from '@/shared/components/ui/SampleTablePagination';
import { useTableColumnsInventarioSerie } from '@/shared/hooks/useTableColumnsInventarioSerie';
import { useCargarSeriesProductos } from '@/store/erp/productos/useCargarSeriesProductos.store';
import DatosTransferenciaComponente from '@/erp/inventario/componente/datos-transferencia-componente';
import { IDataTransferenciaInventario } from '@/erp/inventario/componente/datos_transferencia_componente.interface';
import { useBodegaStore } from '@/store/erp';
import { useAuthStore } from '@/store/auth';
import { useFetchPostTransitoInventario } from '@/shared/actions/erp/transito_inventaro.actions';
import ModalInventariableProductoFactor from '@/shared/components/ui/CargarSeries/ModalInventariableProductoFactor';

export default function TrasladoInventarioAccionPage() {
  const navigate = useNavigate();
  const { idtraslado } = useParams();

  //STORE
  const setAlert = useUiStore(s => s.setAlert);
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const { columnsTrasladoInventarioPorSolc } = useTableColumnsInventarioSerie();
  const handleAgregarUrlSerie = useCargarSeriesProductos(s => s.handleAgregarUrlSerie)
  const { handleUploadFile } = useUploadFile();
  const { ubicacionTransito, bodegaTransito } = useBodegaStore();
  const username = useAuthStore(s => s.user?.username);


  ///* react query

  const {
    data: dataTransferenciaInventario,
    isLoading: isLoadingTransferenciaInventario
  } = useFetchSolicitudTransferenciaInventarioById(idtraslado!);

  const {
    mutateAsync: mutateAsyncTransferenciaProducto,
    isPending: isPendingTrasladoInventario
  } = useFetchCreateTransferenciaInventario();

  const {
    mutateAsync: mutateAsyncPostTransito
  } = useFetchPostTransitoInventario({})

  const {
    mutateAsync: mutateAsyncPutSolicitudTraslado
  } = useFetchPutSolicitudTraslado()

  ///* form
  const form = useForm<ISolicitudTrasladoForm, any, ISolicitudTrasladoForm>({
    defaultValues: {
      es_transito: false,
      bodega_origen_externa: true,
      bodega_destino_externa: true,
    }
  });

  const {
    reset,
    control,
    formState: { errors },
  } = form;

  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);

  const onSubmit = async () => {

    if (productos.length === 0)
      return setAlert(true, 'Agregar inventariables', AlertSeverityEnum.info)

    const productoConError = productos.find(({ contiene_serie, series, cantidad }) =>
      contiene_serie && (
        series?.length == 0 || series?.length! != cantidad
      )
    );

    console.log(productoConError?.series?.length, 'producto');

    if (productoConError) {
      const { codigo } = productoConError.producto_data ?? {};
      const mensaje = productoConError.series?.length == 0
        ? `El producto con el código ${codigo} tiene series pendientes por cargar.`
        : `El producto con el código ${codigo} tiene una discrepancia entre la cantidad ingresada y las series cargadas. Por favor, revisa la información y vuelve a intentarlo.`;

      return setAlert(true, mensaje, AlertSeverityEnum.error);
    }


    setConfirmDialogIsOpen(true);
    setConfirmDialog({
      cancelTextBtn: 'Salir',
      isOpen: true, title: '¡Confirmar!', subtitle: 'Confirmar que deseas proceder con el traslado de inventario. Esta acción es irreversible. ¿Estás seguro de continuar?',
      onClose() {
        setConfirmDialogIsOpen(false)

      }, async onConfirm() {

        try {

          setConfirmDialogIsOpen(false);

          const getForm = form.getValues();

          const newProductoData = await handleAgregarUrlSerie(handleUploadFile);

          if (!newProductoData) {
            return setAlert(true, "Error al procesar los productos", AlertSeverityEnum.error);
          }

          delete dataTransferenciaInventario?.codigo;
          delete dataTransferenciaInventario?.numero_referencia;

          const traslado: any = {
            ...dataTransferenciaInventario,
            es_transito: getForm.es_transito,
            productos: newProductoData,
            user: username!,
            observaciones: {
              observaciones_1: form.getValues().observacion_1
            },
            traslado_inicial: null,
            fecha: formatDate(new Date),
          }

          const esBodegaGeneral = !getForm.bodega_destino_externa && !getForm.bodega_origen_externa;

          if (esBodegaGeneral) {
            if (getForm.es_transito) {

              ///* genera movimiento 
              const resp = await mutateAsyncTransferenciaProducto({
                ...traslado,
                solicitud_transferencia: dataTransferenciaInventario?.codigo,
                bodega_destino: bodegaTransito?.codigo,
                ubicacion_destino: ubicacionTransito?.codigo
              });

              const materialList = traslado.productos?.map((element: MaterialTransferido) => {
                return {
                  ...element,
                  cantidad_esperada: element.cantidad,
                  cantidad_acumulada: "0",
                  cantidad: "0"
                };
              });

              traslado.bodega_transito = bodegaTransito?.codigo;
              traslado.ubicacion_transito = ubicacionTransito?.codigo;
              traslado.productos = materialList;
              traslado.traslado_inicial = resp.data.codigo;
            }

            await mutateAsyncPostTransito({
              ...traslado,
              estado_transito: getForm.es_transito
                ? EstadoTransitoInventarioENUM.EN_TRANSITO
                : EstadoTransitoInventarioENUM.EN_ESPERA
            });

          } else {
            ///* cuando es de bodega a bodega externa o viceversa se genera una transferencia directa
            await mutateAsyncTransferenciaProducto(traslado);
          }

          await mutateAsyncPutSolicitudTraslado({
            id: dataTransferenciaInventario?.id_solicitudtraslado!,
            data: {
              estado_solicitud: EstadoSolicitudTransferencia.FINALIZADO
            }
          })

          clearSelectedItems();
          navigate(ROUTER_PATHS.inventario.trasladoInventario);




          /*  setConfirmDialogIsOpen(false)
 
           const newProductoData = await handleAgregarUrlSerie(handleUploadFile);
 
           dataTransferenciaInventario!.solicitud_transferencia = dataTransferenciaInventario?.codigo!;
           dataTransferenciaInventario!.productos = newProductoData!
           dataTransferenciaInventario!.fecha = formatDate(new Date)
 
           dataTransferenciaInventario!.estado_solicitud =
             EstadoSolicitudTransferencia.FINALIZADO;
 
           const resp = await fetchCreateTransferenciaProducto(dataTransferenciaInventario! as any);
 
           if (resp.code != 200)
             return setAlert(true, `Lo sentimos ocurrio un error al generar traslado de inventario [${resp.code}]`, AlertSeverityEnum.error);
 
           if (!dataTransferenciaInventario?.bodega_origen_data.es_externa && !dataTransferenciaInventario?.bodega_destino_data.es_externa) {
             mutateAsyncRecepcion({
               traslado_inventario: resp.data.codigo,
               solicitud_traslado: dataTransferenciaInventario!.codigo
             })
           }
           clearSelectedItems();
           navigate(ROUTER_PATHS.inventario.trasladoInventario); */

        } catch (error) {

          console.log(error);

        }

      },
    });


  }

  useEffect(() => {

    if (isLoadingTransferenciaInventario) return;

    if (dataTransferenciaInventario?.estado_solicitud === EstadoSolicitudTransferencia.FINALIZADO) {
      setAlert(true, 'La transferencia de inventario ya ha sido gestionada.', AlertSeverityEnum.info)
      navigate(ROUTER_PATHS.inventario.trasladoInventario);
      return
    }

    ///* cargar inicial de datos

    const detalle: MaterialTransferido[] = dataTransferenciaInventario?.productos!
    handleCopiarLista(detalle);

    reset({
      bodega_destino_externa: dataTransferenciaInventario?.bodega_destino_data.es_externa,
      bodega_origen_externa: dataTransferenciaInventario?.bodega_origen_data.es_externa
    })
    return () => {
      clearSelectedItems();
    };
  }, [dataTransferenciaInventario]);



  if (isLoadingTransferenciaInventario
    || isPendingTrasladoInventario)
    return <LoaderComponent />;

  return (
    <>
      <SingleTableBoxScene
        title="Transferencia de Inventario por Solicitud"
        visibleReport={false}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.trasladoInventario}
        //showRechazarBtn={true}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Transferir"
        iconCreateOrEdit={<LocalShippingIcon />}
        fnCreateOrEdit={onSubmit}
      >
        <Grid
          item
          {...gridSizeMdLg12}
          style={{
            padding: '40px 20px',
          }}
        >
          <Grid container spacing={3}>
            <DatosTransferenciaComponente
              control={control}
              errors={errors}
              form={form}
              reset={reset}
              dataTransferenciaInventario={dataTransferenciaInventario as IDataTransferenciaInventario}
              onChangeDeleteItem={() => {
                clearSelectedItems();
              }}
            />

            {!form.getValues().bodega_destino_externa && !form.getValues().bodega_origen_externa && (
              <Grid item xs={12}>
                <SampleCheckbox
                  label={texto.transito_inventario}
                  name="es_transito"
                  control={form.control}
                  defaultValue={!!form.getValues().es_transito}
                  size={gridSizeMdLg12}
                  onChangeValue={(value) => {
                    reset({
                      ...form.getValues(),
                      es_transito: value
                    })
                  }}
                />
              </Grid>
            )}


            <Grid item {...gridSize}>
              <Paper className="paper-producto">
                <Grid
                  container
                  spacing={1}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  <Grid item>
                    <TabTextLabel
                      text={'Items Seleccionado'}
                      mt={0}
                      pb={0}
                      pl={0}
                      pt={0}
                    />
                  </Grid>

                  <div className="linea"></div>
                  <Grid item xs={12}>
                    <SampleTablePagination
                      columns={columnsTrasladoInventarioPorSolc}
                      data={paginatedData}
                      rowCount={productos.length}
                      setPagination={setPagination}
                      pagination={pagination}
                      rowNumber={true}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </SingleTableBoxScene >

      {/* <ModalProductoSeries
        generarSerie={false}
        seleccionarAutomatico={true}
        seleccionarManual={true}
        size={gridSizeMdLg3}
      /> */}

      <ModalInventariableProductoFactor
        generarSerie={false}
        seleccionarAutomatico={true}
        seleccionarManual={true}
        size={gridSizeMdLg4}
      />
    </>
  );
}
